import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardCardComponent {
  @HostBinding('class.dashboard-card') dashboardCardClass = true;

  @Input() layout: 'compact' | 'metric' = 'compact';

  @HostBinding('class.dashboard-card--metric')
  get metricClass(): boolean {
    return this.layout === 'metric';
  }

  @HostBinding('class.dashboard-card--compact')
  get compactClass(): boolean {
    return this.layout === 'compact';
  }
}

